import { api } from '@/common/api';
import { request } from '@kibt/krn-utils';

import { createWithEqualityFn } from 'zustand/traditional';
import isEqual from 'lodash/isEqual';
import { POINT_TYPE } from '@/component/ShoppingCartIcon/model';
import { isLogin } from '@/common/const';
import { reportCatchError } from '@/utils/reportCatchError';

interface ICartCountResponse {
    result: number;
    data: {
        skuCount: number;
        tagList: {
            tagType: POINT_TYPE;
        }[];
    };
}

export const useCartCountStore = createWithEqualityFn(
    (set: any, get: any) => ({
        cartCount: 0,
        cartSkuFirstTag: null as POINT_TYPE,
        fetchFinished: false,
        increaseCartCount: () => set({ cartCount: get().cartCount + 1 }),
        setCartCount: (count: number) => set({ cartCount: count }),
        setCartSkuFirstTag: (tag: POINT_TYPE) => set({ cartSkuFirstTag: tag }),
    }),
    isEqual
);

export async function initCartCount(): Promise<void> {
    if (!isLogin) {
        return null;
    }
    try {
        const res: ICartCountResponse = await request.get(api('/rest/o/ecommerce/customer/shopCart/state'), {});
        if (res?.result === 1) {
            const result: any = {
                fetchFinished: true,
            };
            if (res?.data?.skuCount >= 0) {
                result.cartCount = res.data.skuCount;
            }
            if (res?.data?.tagList?.length) {
                result.cartSkuFirstTag = res.data.tagList?.[0]?.tagType;
            }
            useCartCountStore.setState(result);
        }
    } catch (error) {
        console.log('rest/o/ecommerce/customer/shopCart/state error', error);
    }
}
